import { useState } from 'react';

import { CcrcBottom, CcrcDetail } from 'widgets/Ccrc/ui';
import { Fallback, Toast } from 'shared/ui';
import { CommonCenterModal } from 'shared/ui/Modal';
import warningIcon from 'styles/images/icon_t_warning.svg';

import { usePostUploadedImage, useUploadImage } from '../model';
import { useGetSearchParams } from '../model/useGetSearchParams';

import { UploadImage } from './UploadImage';

export const MedicalReferralPage = () => {
  const [showCcrcDetail, setShowCcrcDetail] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const { hspId, hspCd, acptNo, ccrcGuidId, ptMpiKey, fileDataType, redirectUrl } = useGetSearchParams();
  const { images, handleImageUpload, handleRemoveImage, imageUploadError, setImageUploadError } = useUploadImage();
  const { handlePostUploadedImage, isLoading, isError, setIsError } = usePostUploadedImage(redirectUrl);

  if (isLoading) return <Fallback />;
  if (showCcrcDetail)
    return (
      <CcrcDetail
        params={{ ccrcGuidId, hspId, hspCd }}
        handleSubmit={() => {
          setShowCcrcDetail(false);
          setIsAgreed(true);
        }}
      />
    );

  return (
    <>
      <div className='container-doc container-guide'>
        <div className='container-wrap medi-refer'>
          <div className='content-area'>
            <div className='title-area'>
              <h2 className='header-tit-02'>진료의뢰서를 병원에 보내주세요</h2>
              <span className='sub-tit-01'>
                진료의뢰서를 병원에 보내시면, 병원에서 예약이 정확한지 확인해 드릴 수 있어요.
              </span>
            </div>

            <div className='main-area'>
              <UploadImage
                images={images}
                handleImageUpload={handleImageUpload}
                handleRemoveImage={handleRemoveImage}
              />
              <p className='upload-limit'>• 사진은 최대 5장까지 보낼 수 있어요.</p>
            </div>
          </div>
          <CcrcBottom
            isAgreed={isAgreed}
            setIsAgreed={setIsAgreed}
            handleSubmit={() => handlePostUploadedImage(images, hspId, hspCd, acptNo, ptMpiKey, fileDataType)}
            handleDetailClick={() => {
              setShowCcrcDetail(true);
            }}
            ccrcText='[필수] 민감정보 수집·이용 동의'
            btnText='전송하기'
            activeSubmit={images.length > 0}
          />
        </div>
      </div>
      <CommonCenterModal
        title='진료의뢰서 전송 실패'
        subTitle={
          <>
            연결 상태가 좋지 않아 전송되지 않았어요. <br /> 잠시 후 다시 시도해주세요.
          </>
        }
        btnText='확인'
        show={isError}
        handleClose={() => setIsError(false)}
      />

      {imageUploadError && (
        <Toast
          icon={warningIcon}
          close={() => setImageUploadError(false)}
          dissolve={true}
          text={'사진 업로드는 최대 5개까지 가능해요.'}
        />
      )}
    </>
  );
};
